/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import SelectInput from '@brands/Components/Inputs/SelectInput/SelectInput';
import SmileScanMobile from '@brands/Dashboard/Dashboard/Patient/utils/smile_scan_mobile.svg';
import uploadImage from '@brands/Dashboard/PatientForms/PatientForm/ImageUpload/assets/drag-image-icon.svg';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import useSubscribe, { Subscriber } from '@brands/hooks/useSubscribe';
import { setUserWebState } from '@brands/services/auth/setUserWebState';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectIsAdminLoginNewDesign } from '@brands/store/selectors/isAdminNewDesign';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setForm, UploadedFile } from '@brands/store/slices/patientFormSlice';
import store from '@brands/store/store';
import { selectCommonCustomStylesSlim } from '@brands/Utils/customStyles';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { clearPreviewCache } from '@brands/Utils/mediaPreviewCache';
import { uploadIntakeImage } from '@brands/Utils/uploadIntakeImage';
import { UploadedFileImage } from '@brands/Components/UploadedFileImage/UploadedFileImage';
import { isStaffCaseCreationRole } from '@brands/Utils/reviewProfileBasePath';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { red } from '@mui/material/colors';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from '../../../../Components/Button/Button';
import Container from '../../../../Components/Container/Container';
import ProgressBar from '../../../../Components/ProgressBar/ProgressBar';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useReduxHook';
import useWindowSize from '../../../../hooks/useWindowSize';
import MobileHandoffModal from './Components/MobileHandoffModal';
import styles from './styles.module.scss';

type Option = {
  value: any;
  label: string;
};


const ImageUploadWeb = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const isAdminNewDesign = useSelector(selectIsAdminLoginNewDesign);
  const screenSize = useWindowSize();
  const { state, search } = useLocation();
  const isMobile = screenSize.width < 768;
  const { userInfo } = useAppSelector(selectAuth);
  const [useintraoralCamera, setUseIntraoralCamera] = useState(false);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const { currentOrganizationPrices } = useAppSelector(selectOrganizationPrices);
  const [displayMobileHandOffModal, setDisplayMobileHandOffModal] = useState(false);
  const queryParams = useMemo(() => queryString.parse(search), [search]);
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const currentState: Record<number, string> = useAppSelector(selectCurrentPatientState);
  const [cameraDevices, setCameraDevices] = useState<MediaDeviceInfo[]>([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);
  const [capturedImages, setCapturedImages] = useState<UploadedFile[]>([]);
  const [capturing, setCapturing] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const captureButtonRef = useRef<HTMLButtonElement>(null);
  const capturingRef = useRef(false);
  const caseType = values.find((item) => item.form_question_id === 20)?.value.caseType as string;
  const shouldShowButton = useintraoralCamera || (caseType !== 'one_report' && caseType !== 'second_opinion');
  const updateCameraDevices = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter((d) => d.kind === 'videoinput');

      setCameraDevices(videoDevices);

      if (videoDevices.length > 0) {
        if (!selectedDeviceId || !videoDevices.some((device) => device.deviceId === selectedDeviceId)) {
          setSelectedDeviceId(videoDevices[0].deviceId);
        }
      } else {
        setSelectedDeviceId(null); // No devices available
      }

      // Stop the temporary stream used for enumeration
      stream.getTracks().forEach((track) => track.stop());
    } catch (err) {
      console.error('Error enumerating devices:', err);
      setCameraDevices([]);
      setSelectedDeviceId(null);
    }
  }, [selectedDeviceId]);

  async function ensureCameraPermission(): Promise<boolean> {
    try {
      const result = await navigator.permissions.query({ name: 'camera' as PermissionName });
      if (result.state === 'granted') {
        return true;
      }
      if (result.state === 'prompt') {
        // Will trigger prompt on getUserMedia
        return await requestCameraAccess();
      }
      if (result.state === 'denied') {
        alert('Camera access is blocked. Please enable it in your browser settings.');
        return false;
      }
    } catch (err) {
      // Fallback for browsers without navigator.permissions
      return requestCameraAccess();
    }
    return false;
  }

  async function requestCameraAccess(): Promise<boolean> {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      // stop tracks after confirming access
      stream.getTracks().forEach((track) => track.stop());
      return true;
    } catch (err) {
      console.error('Camera access denied:', err);
      return false;
    }
  }

  // Initialize camera devices and set up devicechange listener
  useEffect(() => {
    if (!useintraoralCamera) return;

    updateCameraDevices();

    navigator.mediaDevices.addEventListener('devicechange', updateCameraDevices);

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', updateCameraDevices);
    };
  }, [useintraoralCamera, updateCameraDevices]);

  useEffect(() => {
    if (!useintraoralCamera || !selectedDeviceId) return;

    const startVideoStream = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: { exact: selectedDeviceId } },
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play().catch((err) => console.error('Error playing video:', err));
        }
        if (captureButtonRef.current) {
          captureButtonRef.current?.focus();
        }
      } catch (err) {
        console.error('Error accessing camera:', err);
      }
    };

    startVideoStream();

    return () => {
      if (videoRef.current?.srcObject instanceof MediaStream) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
        videoRef.current.srcObject = null;
      }
    };
  }, [selectedDeviceId, useintraoralCamera]);

  // Intraoral cameras send a Space press, which only captures while this button
  // has focus. Disabling it during an upload drops focus to the page, so hand it
  // back once the button is usable again or every shot after the first is lost.
  useEffect(() => {
    if (useintraoralCamera && !capturing) captureButtonRef.current?.focus();
  }, [useintraoralCamera, capturing]);

  // Clicking the preview or anything else unfocusable also leaves focus on the
  // page, so a Space press with nothing focused still captures.
  useEffect(() => {
    if (!useintraoralCamera) return undefined;
    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.code !== 'Space' || event.repeat || document.activeElement !== document.body) return;
      event.preventDefault();
      captureButtonRef.current?.focus();
      captureButtonRef.current?.click();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [useintraoralCamera]);

  const captureImage = async (): Promise<void> => {
    if (capturingRef.current || !videoRef.current) return;
    capturingRef.current = true;
    setCapturing(true);
    try {
      const canvas = document.createElement('canvas');
      canvas.width = videoRef.current.videoWidth;
      canvas.height = videoRef.current.videoHeight;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
      const blob: Blob | null = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
      if (!blob) return;
      const filename = `Capture-${capturedImages.length + 1}.png`;
      const file = new File([blob], filename, { type: 'image/png' });
      const uploaded = await uploadIntakeImage(file, userInfo?.role?.name);
      setCapturedImages((prev) => [...prev, uploaded]);
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      capturingRef.current = false;
      setCapturing(false);
    }
  };

  const deleteImage = (index: number): void => {
    setCapturedImages((prev) => {
      const removed = prev[index];
      if (removed?.media_id) clearPreviewCache(removed.media_id);
      return prev.filter((_, i) => i !== index);
    });
    captureButtonRef.current?.focus();
  };

  const cameraOptions: Option[] = cameraDevices.map((device) => ({
    value: device.deviceId,
    label: device.label || 'Camera',
  }));

  // Initialize synchronously from the JWT cookie so the QR renders on the
  // first paint — the mobile receiver authenticates from `?auth=<JWT>` and
  // re-fetches its own state. We don't gate the QR on the setUserWebState
  // round-trip anymore.
  const [newUrl, setNewUrl] = useState<string>(() => {
    const initialJwt = Cookies.get('jwtToken');
    if (!initialJwt) return '';
    const url = new URL(window.location.href);
    url.searchParams.set('auth', encodeURIComponent(initialJwt));
    return url.toString();
  });

  const subscriber: Subscriber = useMemo(
    () => ({
      onMessage: (message: Record<string, any>) => {
        if (['mobile_handoff'].includes(message.command)) {
          setDisplayMobileHandOffModal(true);
        } else if (['mobile_case_creation_complete'].includes(message.command)) {
          setDisplayMobileHandOffModal(false);
          goToDashboard();
        }
      },
      commands: ['mobile_handoff', 'mobile_case_creation_complete'],
    }),
    [setDisplayMobileHandOffModal],
  );
  const { subscribe, unsubscribe } = useSubscribe();

  useEffect(() => {
    const subscriptionId = subscribe(subscriber);

    return () => unsubscribe(subscriptionId);
  }, [subscribe, unsubscribe, subscriber]);

  useEffect(() => {
    const painQuestion = values.find((item) => item.form_question_id === 16)?.value;

    const isPainValid = () => {
      if (!painQuestion) return false;

      const { painLevel, describePain, daysInPain } = painQuestion;

      if (!painLevel) return false;

      if (painLevel !== 'noPain' && (!describePain || (describePain as string[]).length === 0)) return false;

      if (painLevel !== 'noPain' && !daysInPain) return false;

      return true;
    };

    if (!isPainValid()) {
      if (isAdminNewDesign) {
        roleNavigate('/describe-pain-level');
      } else roleNavigate('/describe-pain-level');
    }
  }, [values]);

  const appendStateToUrl = (jwtToken: string): string => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);

    // Set the 'auth' parameter with the JWT token
    url.searchParams.set('auth', encodeURIComponent(jwtToken));

    return url.toString();
  };

  const goToDashboard = useCallback(() => {
    if (
      userInfo.role.name === UserRoleName.Admin ||
      userInfo.role.name === UserRoleName.SuperAdmin ||
      userInfo.role.name === UserRoleName.OrganizationAdmin
    ) {
      navigate(`/${userInfo.role.name}/review-profile/Patient/${state.patientId}`);
    } else if (isAdminNewDesign) {
      roleNavigate('/dashboard');
    } else roleNavigate('/dashboard');
  }, [userInfo.role.name, navigate]);

  useEffect(() => {
    if (queryParams.auth !== undefined || queryParams.state) return;

    // Sync handoff state to the server in the background. The QR was
    // already rendered synchronously via the useState initializer above,
    // so we no longer gate the user-visible page on this POST. The
    // payload is intentionally tiny: no `auth`, no full organization, no
    // pricings — the mobile receiver re-fetches anything heavy with the
    // JWT it gets from the QR URL.
    const syncStateInBackground = async (): Promise<void> => {
      const reduxState = store.getState();
      const { pageState } = reduxState;

      const selectedState = {
        patientForm: reduxState.patientForm,
        selectedPatient: currentPatient,
        pageState,
        organization_id: currentOrganization?.id,
        refreshToken: Cookies.get('refreshToken'),
        jwtTokenExpire: Cookies.get('jwtTokenExpire'),
        patientState: !(
          userInfo.role.name === UserRoleName.Admin ||
          userInfo.role.name === UserRoleName.SuperAdmin ||
          userInfo.role.name === UserRoleName.OrganizationAdmin
        )
          ? userInfo.id in currentState
            ? { [userInfo.id]: currentState[userInfo.id] }
            : {}
          : { [currentPatient?.id]: currentState[currentPatient?.id] },
      };

      try {
        await setUserWebState(selectedState);
      } catch (error: unknown) {
        // Best-effort: the QR is already on screen.
        displayErrorDetails(error);
      }
    };
    void syncStateInBackground();
  }, [queryParams]);

  const onBack = (): void => {
    if (useintraoralCamera) {
      const videoElement = document.querySelector('video');
      const stream = videoElement?.srcObject as MediaStream | null;

      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      setUseIntraoralCamera(false);
    } else {
      dispatch(setForm([...values!]));
      navigate(-1);
    }
  };

  const movetoNextPage = (): void => {
    const existingAnswer = values!.find((item) => item.form_question_id === 17);
    const existingImages = (existingAnswer?.value?.images ?? []) as UploadedFile[];

    const allImages = [...existingImages, ...capturedImages];

    const filteredPayload = values!.filter((item) => item.form_question_id !== 17);

    filteredPayload.push({
      form_question_id: 17,
      value: { images: allImages },
    });

    dispatch(setForm(filteredPayload));

    const videoElement = document.querySelector('video');
    const stream = videoElement?.srcObject as MediaStream | null;

    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    setUseIntraoralCamera(false);

    if (isAdminNewDesign) {
      roleNavigate('/upload-image-flow');
    } else roleNavigate('/upload-image-flow');
  };

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
      }}
      childrenStyle={{ zIndex: '2' }}
    >
      <div className={styles.uploadImageContainer}>
        <div className={styles.uploadImageContainerDiv}>
          <ProgressBar currentStep={3} totalSteps={4} onBack={onBack} hideStepNumbers />
          {!useintraoralCamera ? (
            <>
              <div className={`${styles.formTitle} d-flex mt-3 fs-unmask`}>
                {(values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'one_report' ||
                (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'second_opinion'
                  ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'one_report'
                    ? 'Attachment upload'
                    : 'Attachment Upload *'
                  : 'Attachment upload'}
              </div>
              <div className={styles.uploadImageQRContainer}>
                <div>
                  {' '}
                  <img className={styles.smileScanMobile} src={SmileScanMobile} alt="SmileScanMobile" />
                </div>
                <div className={styles.uploadImageQRContainerText}>
                  <span className={`fs-unmask ${styles.uploadImageQRContainerText1}`}>
                    Use Our Guided Image Capture
                  </span>
                  <span className={`fs-unmask ${styles.uploadImageQRContainerText2}`}>
                    For a more seamless experience continue from your phone
                  </span>
                  <span className={`fs-unmask ${styles.uploadImageQRContainerText3}`}>
                    Use the QR code to get started.
                  </span>
                </div>
                <div className="fs-exclude">
                  <QRCode value={newUrl} size={150} />
                </div>
              </div>
              <div className={styles.uploadImageQRFooter}>
                <div>
                  <img
                    className={`fs-unmask ${styles.uploadImageQRFooterImage}`}
                    src={uploadImage}
                    alt="Upload Imahe"
                  />
                </div>
                <div className={`fs-unmask ${styles.uploadImageQRFooterText}`}>
                  <span className={styles.clickHere}>
                    <a
                      onClick={() => roleNavigate('/upload-image-flow')}
                    >
                      Click Here
                    </a>
                  </span>{' '}
                  to upload images of your mouth and teeth from your computer.
                </div>
              </div>
              {!isMobile &&
                (userInfo.role.name === UserRoleName.Admin ||
                  userInfo.role.name === UserRoleName.SuperAdmin ||
                  userInfo.role.name === UserRoleName.OrganizationAdmin) && (
                  <div className={`fs-unmask ${styles.uploadImageIntraoralCamera}`}>
                    <span>
                      If you’re a provider using an intraoral camera to capture these images,{' '}
                      <a
                        onClick={async () => {
                          const granted = await ensureCameraPermission();
                          if (granted) {
                            setUseIntraoralCamera(true);
                          }
                        }}
                      >
                        click here.
                      </a>
                    </span>
                  </div>
                )}
            </>
          ) : (
            <div className={`fs-unmask ${styles.previewSection}`}>
              <video ref={videoRef} autoPlay playsInline muted />
              <div className={`fs-unmask ${styles.imageStrip}`}>
                {capturedImages.map((img, i) => (
                  <div className={`fs-unmask ${styles.imageWrapper}`} key={img.media_id ?? `${img.name}-${i}`}>
                    <UploadedFileImage file={img} userRole={userInfo?.role?.name} alt={`Capture ${i + 1}`} />
                    <CancelIcon
                      sx={{ color: red }}
                      className={`fs-unmask ${styles.delete}`}
                      onClick={() => deleteImage(i)}
                    />
                  </div>
                ))}
              </div>
              <button ref={captureButtonRef} className={`fs-unmask ${styles.captureButton}`} onClick={() => void captureImage()} disabled={capturing}>
                <CameraAltIcon />
              </button>
              <div className={`fs-unmask ${styles.cameraSelector}`}>
                <SelectInput
                  name="camera"
                  options={cameraOptions}
                  style={selectCommonCustomStylesSlim}
                  containerClass={styles.inputWrapper}
                  selectorClass={styles.selector}
                  selectedValue={cameraOptions.find((opt) => opt.value === selectedDeviceId)}
                  onChange={(value) => {
                    setSelectedDeviceId(value?.value);
                  }}
                  isClearable={false}
                />
              </div>
            </div>
          )}

          {shouldShowButton && (
            <div className={styles.btnContainer}>
              <Button
                type="button"
                style={{ width: '245px', height: '46px' }}
                onClick={() => {
                  if (!useintraoralCamera) {
                    const medicalSummaryState = {
                      caseType: state
                        ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string)
                        : '',
                      patientId: selectedPatient?.value || '',
                      shouldSeeLastModal: false,
                      fromPatientIntake: true,
                    };
                    if (isAdminNewDesign) {
                      roleNavigate('/medical-information-summary');
                    } else if (isStaffCaseCreationRole(userInfo.role.name)) {
                      roleNavigate('/medical-information-summary', { state: medicalSummaryState });
                    } else
                      roleNavigate('/medical-information-summary', {
                        state: medicalSummaryState,
                      });
                  } else {
                    movetoNextPage();
                  }
                }}
                disabled={useintraoralCamera && capturedImages.length === 0}
              >
                {useintraoralCamera ? 'Next' : 'Skip'}
              </Button>
            </div>
          )}
        </div>
        {displayMobileHandOffModal && <MobileHandoffModal />}
      </div>
    </Container>
  );
};
export default ImageUploadWeb;
